import Swup from 'swup';
import { initHamburger } from './modules/hamburger';
import { initSliders, destroySliders } from './modules/sliders';
import { initContact } from './modules/contact';
import { initBlogGrid } from './modules/blog-grid';
import { menuScroll, closeMenu } from './modules/menu';
import { animateTitles } from './modules/animateTitles';
import { initReveal } from './modules/animationReveal';
import { initParallax } from './modules/parallax';
import { initLoader } from './modules/loader';
import { ScrollTrigger } from './utils/gsap';
import SwupBodyClassPlugin from '@swup/body-class-plugin';


function destroyPage() {
  ScrollTrigger.getAll().forEach(t => t.kill());
  if (window.ScrollReveal) {
    try { ScrollReveal().destroy(); } catch (e) {}
  }
  destroySliders();
}

function initPage() {
  animateTitles();
  initReveal();
  initParallax();
  initSliders();
  initContact();
  initBlogGrid();
}

document.addEventListener('DOMContentLoaded', () => {
  initLoader();
  menuScroll();
  initHamburger();
  initPage();

  const swup = new Swup({
    containers: ['#swup'],
    plugins: [new SwupBodyClassPlugin()]
  });

  swup.hooks.before('animation:out:start', () => {
    closeMenu();
  });

  swup.hooks.before('content:replace', () => {
    destroyPage();
  });

  swup.hooks.on('content:replace', () => {
    initPage();
  });
});